import { ensureJqueryEl } from "../../utilities/helpers";
import 'bootstrap-datepicker';
import { initTooltips } from "../../core/initilizers/tooltips";

export class OutsourcingManager {
    constructor(container, isCalledByGetInstance = false) {
        if (!isCalledByGetInstance) {
            throw new Error("ProductConfigurations: Use getInstance() to create instances.");
        }

        this.$container = container;
        this.addBtn = this.$container.find('#addOutsourcing');
        this.config = {};
        this.configuredOutsourcings = {};
        this.outsourcingCount = 0;

        if (this.addBtn.length && this.addBtn.attr('data-outsourcing-config')) {
            this.config = JSON.parse(this.addBtn.attr('data-outsourcing-config'));
            this.outsourcingCount = this.config.count + 1;
        }

        this.init();
    }

    /**
     * @static
     * @method getInstance
     * @description Gets or creates a single instance of OutsourcingManager for a given container.
     * @param {string|jQuery|HTMLElement} container - The container element, jQuery object, or selector string.
     * @returns {OutsourcingManager} The single instance of the class for the provided container.
     */
    static getInstance(container) {
        const $container = ensureJqueryEl(container);

        if (!$container.length) {
            console.warn("OutsourcingManager: Container element not found.");
            return;
        }

        let instance = $container.data('OutsourcingManager');

        if (!instance) {
            instance = new OutsourcingManager($container, true);
            $container.data('OutsourcingManager', instance);
        }

        return instance;
    }

    init() {
        // key of productNodeIDs pointed to array of vendorIDs, used to prevent multiple outsourcing w the same vendor on the same product node

        if (this.config.hasItem) {
            this.configureOutsourcingArray();
        }

        this.attachEvents();

        $("[rel=tooltip]").tooltip({ placement: 'auto' });
        $('.date').datepicker({
            startDate: 'today',
            forceParse: false
        });

        // Trigger change to populate vendor dropdowns on load
        $('.outsourcing-vendor-type').trigger('change');
        this.hideDuplicateProductVendors();
    }
    
    // attach events from the inline scripts inthe blade
    attachEvents() {
        this.$container.on('change', '.outsourcing-vendor-type', (e) => {
            let vendorInput = $(e.target).parents('.outsourcing-item').find('.outsourcing-vendor');
            let type = $(e.target).val();
            let vendors = this.config.vendors;
            let selected = vendorInput.val();

            vendorInput.html('');

            $.each(vendors[type], (i, vendor) => {
                let settings = { value: vendor['id'] };
                if (selected == vendor['id'])
                    settings.selected = 'selected';

                vendorInput.append(
                    $('<option>').attr(settings).html(vendor['name'])
                );
            });
        });

        this.$container.on('click', '.outsourcing-delete', (e) => {
            e.preventDefault();
            let outsourcingItem = $(e.target).parents('.outsourcing-item');
            let vendorID = outsourcingItem.find('.outsourcing-vendor').val();
            let productNodeID = outsourcingItem.find('.outsourcing-product').val();

            //remove configuration from array
            if (productNodeID && this.configuredOutsourcings[productNodeID]) {
                this.configuredOutsourcings[productNodeID].splice(this.configuredOutsourcings[productNodeID].indexOf(vendorID), 1);
            }

            this.hideDuplicateProductVendors();
            outsourcingItem.prev('.outsourcing-separator').remove();
            outsourcingItem.remove();
        });

        this.$container.on('change', '.outsourcing-vendor', (eventObject, args) => {
            if (args !== 'enforce') {
                let newValue = $(eventObject.target).val();
                let oldValue = parseInt($(eventObject.target).attr('data-oldvalue'));
                let productNodeID = $(eventObject.target).parents('.outsourcing-item').find('.outsourcing-product').val();

                if (oldValue !== newValue) {
                    //update old value data attribute
                    $(eventObject.target).attr('data-oldvalue', newValue);

                    if (productNodeID) {
                        //remove productNodeID from oldValue vendor if args is not default
                        if (args !== 'default' && oldValue && this.configuredOutsourcings[productNodeID]) {
                            this.configuredOutsourcings[productNodeID].splice(this.configuredOutsourcings[productNodeID].indexOf(oldValue), 1);
                        }

                        //add productNodeID to the newValue vendor
                        this.addToConfiguredOutsourcingArray(newValue, productNodeID);
                        this.hideDuplicateProductVendors();
                    }
                }
            }
        });

        this.$container.on('change', '.outsourcing-product', (e) => {
            let newValue = $(e.target).val();
            let oldValue = parseInt($(e.target).attr('data-oldvalue'));
            let vendorSelect = $(e.target).parents('.outsourcing-item').find('.outsourcing-vendor');
            let vendorID = vendorSelect.val();

            $(e.target).attr('data-oldvalue', newValue);

            //remove oldValue from array
            if (oldValue) {
                this.configuredOutsourcings[oldValue].splice(this.configuredOutsourcings[oldValue].indexOf(vendorID), 1);
            }
                
            this.showAllOptions(vendorSelect);

            //hide options that are not allowed to be outsourced with this new vendor
            this.applyPreventMultipleOutsourcing(vendorSelect, newValue, $(e.target).parents('.outsourcing-item'));
        });

        this.addBtn.on('click', (e) => {
            e.preventDefault();
            this.addOutsourcing(this.outsourcingCount);
            this.outsourcingCount++;
        });

        this.$container.on('select2:close', '.outsourcing-vendor', (e) => {
            $(e.currentTarget).next('.select2-container').find('.select2-selection').blur();
        });
    }

    // item actions file
    /**
     * Item action mappings and outsourcing have product selections that need to be updated based on the form changes
     * when an option has been changed.
     */
    populateItemActions() {
        let actionOptions = this.populateItemActionOptions();
        this.populateOutsourcing(actionOptions['outsourcing']);

        // we decided to not move items, so no need to populate (keeping code for now)
        // populateItemActionMappings(actionOptions);
    }

    populateOutsourcing(outsourcingOptions) {
        $('.outsourcing-product').each((_,el) => {
            this.addItemActionOptions($(el), outsourcingOptions);
        });
    }

    populateItemActionMappings(actionOptions) {
        let shouldHideMappingContainer = true;
        $('.item-action-mappings').each((_,el) => {
            let options = this.getMappingOptions($(el), actionOptions);
            this.addItemActionOptions($(el), options);
            if ($(el).val() === '') {
                shouldHideMappingContainer = false;
                $(el).parents('.form-group').show();
            }
            else
                $(el).parents('.form-group').hide();
        });

        if (shouldHideMappingContainer)
            $('#itemActionMappingContainer').hide();
        else
            $('#itemActionMappingContainer').show();
    }

    /**
     * actionOptions are the item actions with the options that can be selected for that action.  An option may be in multiple
     * actions.  However, we do not want to display duplicate options in the select, so this function will get the unique options
     * from the actions for the select.
     *
     * @param select
     * @param actionOptions
     */
    getMappingOptions(select, actionOptions) {
        let optionsAdded = [];
        let options = [];

        if (select.data('hasprinting') === 1) {
            for (const actionOption of actionOptions['printing']) {
                if (!optionsAdded.includes(actionOption.productNodeID)) {
                    optionsAdded.push(actionOption.productNodeID);
                    options.push(actionOption);
                }
            }
        }

        if (select.data('hascutting') === 1) {
            for (const actionOption of actionOptions['cutting']) {
                if (!optionsAdded.includes(actionOption.productNodeID)) {
                    optionsAdded.push(actionOption.productNodeID);
                    options.push(actionOption);
                }
            }
        }

        if (select.data('hassewing') === 1) {
            for (const actionOption of actionOptions['sewing']) {
                if (!optionsAdded.includes(actionOption.productNodeID)) {
                    optionsAdded.push(actionOption.productNodeID);
                    options.push(actionOption);
                }
            }
        }

        if (select.data('hasshipping') === 1) {
            for (const actionOption of actionOptions['shipping']) {
                if (!optionsAdded.includes(actionOption.productNodeID)) {
                    optionsAdded.push(actionOption.productNodeID);
                    options.push(actionOption);
                }
            }
        }

        if (select.data('hasscheduling') === 1) {
            for (const actionOption of actionOptions['scheduling']) {
                if (!optionsAdded.includes(actionOption.productNodeID)) {
                    optionsAdded.push(actionOption.productNodeID);
                    options.push(actionOption);
                }
            }
        }

        if (select.data('hasoutsourcing') === 1) {
            for (const actionOption of actionOptions['outsourcing']) {
                if (!optionsAdded.includes(actionOption.productNodeID)) {
                    optionsAdded.push(actionOption.productNodeID);
                    options.push(actionOption);
                }
            }
        }

        return options;
    }

    addItemActionOptions(select, options) {
        let selectedProductNodeID = select.val();
        let selectedName = select.children('option').filter(':selected').text();
        let componentID = select.data('componentid');
        let bundleGroupID = select.data('bundlegroupid');
        let html = '<option value="">Select...</option>';


        // new
        const selectedIds = this.getAllSelectedDataIds();
        /*
        * There are four cases where a selection should be made.  It's also possible that two or more of these cases exist
        * for different options.  We'll choose the option in this order:
        *
        * 1.  there is only one option
        * 2.  previously selected value (compare productNodeID)
        * 3.  matching componentID and bundleGroupID
        * 4.  matching name (the option text)
        */
        let selectedValue = null;
        let previouslySelected = null;
        let matchingIDs = null;
        let matchingName = null;
        for (const option of options) {
            if (options.length === 1)
                selectedValue = option.productNodeID;
            if (selectedProductNodeID === option.productNodeID)
                previouslySelected = selectedProductNodeID;
            else if (previouslySelected === null && componentID === option.componentID && bundleGroupID === option.bundleGroupID)
                matchingIDs = option.productNodeID;
            else if (previouslySelected === null && option.name === selectedName)
                matchingName = option.productNodeID;

            // this checks against the form selected products
            // if(selectedIds.includes(option.productNodeID)) {
                html += this.createItemActionOption(option);
            // }
        }

        if (selectedValue === null && previouslySelected !== null)
            selectedValue = previouslySelected;
        else if (selectedValue === null && matchingIDs !== null)
            selectedValue = matchingIDs;
        else if (selectedValue === null && matchingName !== null)
            selectedValue = matchingName;

        select.html('').append(html);
        if (selectedValue !== null) {
            select.val(selectedValue);
        }     
    }

    populateItemActionOptions() {
        let options = {
            'outsourcing': [],
            'sewing': [],
            'cutting': [],
            'printing': [],
            'shipping': [],
            'scheduling': [],
        };

        let productRoot = $('.product-root');
        options = this.addItemActionOption(productRoot.data('name'), productRoot, options);
        options = this.populateProductSelectionOptions(options);

        return this.populateSingleProductOptions(options);
    }

    populateProductSelectionOptions(itemActions) {

        $('.product-selection').each((_,el) => {
            let productNodeID = $(el).val();
            if ($(el).data('isproduct') === 'yes' && productNodeID !== '' && this.isOptionActive($(el))) {
                let name = $(el).children('option').filter(':selected').text();
                itemActions = this.addItemActionOption(name, $(el), itemActions)
            }
        });

        return itemActions;
    }

    populateSingleProductOptions(itemActions) {
        $('.product-single').each((_,el) => {
            if ($(el).data('isproduct') === 'yes' && this.isOptionActive($(el).closest('.option-set'))) {
                let name = $(el).data('name');

                itemActions = this.addItemActionOption(name, $(el), itemActions);
            }
        });

        return itemActions;
    }

    addItemActionOption(name, option, itemActions) {
        let productNodeID = option.val();
        let componentID = option.data('componentid');
        let bundleGroupID = option.data('bundlegroupid');

        let data = {
            productNodeID: productNodeID,
            componentID: componentID,
            bundleGroupID: bundleGroupID,
            name: name
        };

        if (option.data('canbeoutsourced') === 'yes')
            itemActions['outsourcing'].push(data);

        if (option.data('canbeprinted') === 'yes')
            itemActions['printing'].push(data);

        if (option.data('canbesewing') === 'yes')
            itemActions['sewing'].push(data);

        if (option.data('canbecut') === 'yes')
            itemActions['cutting'].push(data);

        if (option.data('canbeshipped') === 'yes')
            itemActions['shipping'].push(data);

        if (option.data('canbescheduled') === 'yes')
            itemActions['scheduling'].push(data);

        return itemActions;
    }

    createItemActionOption(option) {
        return '<option value="' + option.productNodeID + '">' + option.name + '</option>';
    }

    /**
     * Only product options that are active should be added to outsourcing products.  Sometimes the form is hidden, such as
     * edit multiple, which means that is(:visible) check does not work in those cases.  An option is active as long as no
     * ancestor fieldset is hidden.  The element may be a product selection or an option set.
     *
     * We need to check the element itself and each of its fieldset ancestors.
     */
    isOptionActive(element) {
        if (element.css('display') === 'none') {
            return false;
        }
            
        let isActive = true;
        element.parents('fieldset').each((_,el) => {
            if ($(el).css('display') === 'none')
                isActive = false;
        });

        return isActive;
    }

    // functions from the inline scripts in the blade
    hideDuplicateProductVendors() {
        $.each($('.outsourcing-item:visible'), (_,el) => {
            let vendorSelect = $(el).find('.outsourcing-vendor');
            let vendorID = vendorSelect.val();
            let productSelect = $(el).find('.outsourcing-product');
            let productNodeID = productSelect.val();
            let change = false;

            if (productNodeID in this.configuredOutsourcings) {
                this.showAllOptions(vendorSelect);

                $.each(this.configuredOutsourcings[productNodeID], (_, valueOfElement) => {
                    if (vendorID !== valueOfElement) {
                        vendorSelect.find('option[value=' + valueOfElement + ']').addClass('hidden');
                        change = true;
                    }
                });

                if (change) {
                    vendorSelect.trigger('change', ['enforce']);
                }
            }
        });
    }

    showAllOptions(select) {
        select.find('option.hidden').removeClass('hidden');
    }

    configureOutsourcingArray() {
        $.each($('.outsourcing-item:visible'), (_, el) => {
            let vendorSelect = $(el).find('.outsourcing-vendor');
            let vendorID = vendorSelect.val();
            let productSelect = $(el).find('.outsourcing-product');
            let productNodeID = productSelect.val();

            vendorSelect.attr('data-oldvalue', vendorID);
            productSelect.attr('data-oldvalue', productNodeID);

            this.addToConfiguredOutsourcingArray(vendorID, productNodeID);
        });
    }

    addToConfiguredOutsourcingArray(vendorID, productNodeID) {
        if (this.configuredOutsourcings[productNodeID]) {
            if (this.configuredOutsourcings[productNodeID].indexOf(vendorID) === -1)
                this.configuredOutsourcings[productNodeID].push(vendorID);
        } else {
            this.configuredOutsourcings[productNodeID] = [vendorID];
        }
    }

    applyPreventMultipleOutsourcing(vendorSelect, productID, originalOutsourcing) {
        let optionValuesToHide = this.configuredOutsourcings[productID];
        let selectedVendorID = vendorSelect.find(':selected').val();

        if (optionValuesToHide) {
            $.each(optionValuesToHide, (_, value) => {
                vendorSelect.find('option[value=' + value + ']').addClass('hidden');
                if (value === selectedVendorID) {
                    selectedVendorID = null;
                }
            });
        }

        // use the previous selection unless it is one of the vendors hidden, then use the first vendor
        if (selectedVendorID === null) {
            selectedVendorID = vendorSelect.find('option:not(.hidden)').first().val();
        }
        
        vendorSelect.val(selectedVendorID).trigger('change', ['default']);
        this.addToConfiguredOutsourcingArray(selectedVendorID, productID);

        $.each($('.outsourcing-item'), (_, el) => {
            //comparing DOM objects bc comparing jquery objects does not work
            if ($(el)[0] !== originalOutsourcing[0] && $(el).is(':not(:hidden)')) {
                let vendor = $(el).find('.outsourcing-vendor');
                let product = $(el).find('.outsourcing-product');
                if (product.val() === productID) {
                    //hide new vendor
                    vendor.find('option[value=' + selectedVendorID + ']').addClass('hidden');
                    vendor.trigger('change', ['default']);
                }
            }
        });
    }

    addOutsourcing(outsourcingCount) {
        let outsourcingItems = $('.outsourcing-item');
        let outsourcingItem = outsourcingItems.first().clone();
        let inputName = this.config.baseName + '[' + outsourcingCount + ']';
        let multiplierID = 'multiplier' + outsourcingCount;
        let includeItemPriceID = 'includeItemPrice' + outsourcingCount;

        outsourcingItem.find('.outsourcing-vendor-type').attr('name', inputName + '[type]');
        outsourcingItem.find('.outsourcing-vendor').attr('name', inputName + '[vendorID]');
        outsourcingItem.find('.outsourcing-product').attr('name', inputName + '[productNodeID]');
        outsourcingItem.find('.vendor-quote-number').attr('name', inputName + '[quoteNumber]');
        outsourcingItem.find('.vendor-price').attr('name', inputName + '[price]');
        outsourcingItem.find('.vendor-markup').attr('name', inputName + '[markup]');
        outsourcingItem.find('.vendor-multiplier').attr({
            id: multiplierID,
            name: inputName + '[multiplier]'
        });
        outsourcingItem.find('.vendor-multiplier-not').attr('name', inputName + '[multiplier]');
        outsourcingItem.find('.vendor-include-item-price').attr({
            id: includeItemPriceID,
            name: inputName + '[includeItemPrice]',
        });
        outsourcingItem.find('.vendor-include-item-price-not').attr('name', inputName + '[includeItemPrice]');
        outsourcingItem.find('.vendor-notes').attr('name', inputName + '[notes]');
        outsourcingItem.find('fieldset').prop('disabled', false);
        outsourcingItem.find('.vendor-multiplier-label').attr('for', multiplierID);
        outsourcingItem.find('.vendor-include-item-price-label').attr('for', includeItemPriceID);
        outsourcingItem.find('.vendor-ship-to').attr('name', inputName + '[shipTo]');
        outsourcingItem.find('.vendor-receive-date').attr('name', inputName + '[expectedReceiveDate]');

        let vendorID = outsourcingItem.find('.outsourcing-vendor').val();
        outsourcingItem.find('.outsourcing-vendor').attr('data-oldvalue', vendorID);

        outsourcingItem.show();
        if (outsourcingItems.length > 1) {
            $('.outsourcing-list-form').append(
                $('<hr>').attr({ class: 'outsourcing-separator' })
            );
        }

        $(".outsourcing-list-form").append(
            outsourcingItem
        );

        initTooltips();
        $('.date').datepicker({
            startDate: 'today',
            forceParse: false
        });

        outsourcingItem.find('.outsourcing-vendor').select2({
            dropdownParent: outsourcingItem,
            width: '100%',
            // This function runs for every option in the list
            templateResult: function(option, container) {
                // Check if the original <option> element has the 'hidden' class
                if (option.element && $(option.element).hasClass('hidden')) {
                    $(container).css('display', 'none');
                }
                return option.text;
            }
        });
    }

    /**
     * Gathers a list of all selected data-node values from a product configuration form.
     * @param {jQuery} $form - The jQuery object of the form container.
     * @returns {Array<string>} An array containing the data-node values of all selected options.
     */
    getAllSelectedDataIds() {
        const formEl = $(this.$container).is('form') ? this.$container : this.$container.find('form');

        const formDataArray = formEl.serializeArray();
        let formValues = formDataArray.filter(item =>
            (item.name.includes('item-nodes[children]') ||
                item.name.includes('item-nodes[productNodeID]')) &&
            !isNaN(Number(item.value)) &&
            Number(item.value) > 0
        );
        formValues = formValues.map(item => item.value);

        return formValues;
    }
}

const initOutsourcingManager = (container) => {
    return OutsourcingManager.getInstance(container);
}
export default initOutsourcingManager;